<template lang="pug">
  .container-error
    .item
      h1
        font-awesome-icon.item-icon(icon="phone-slash")
        span {{ $t('ERROR !')}}
    .item.description
      h6 {{ $t('You were disconnected from server')}}
    .item.description
      h4 {{ $t('Trying to reconnect...')}}
    .item
    .item.item-acknowledge
      el-button(id="Error400-websocketButton" type="warning", size="small", @click="reloadApp()", plain)
        span {{ $t('Go to Log-in screen') }}
</template>
<script>
export default {
  props: ['error'],
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
    reloadApp () {
      window.location.reload()
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
@import "./error.scss";
</style>



// WEBPACK FOOTER //
// src/components/Error/errorWebsocket.vue